import {Checkbox as ArkCheckbox} from '@ark-ui/react/checkbox'

export const CheckboxHiddenInput = ArkCheckbox.HiddenInput
